import { render, staticRenderFns } from "./kindFile.vue?vue&type=template&id=680bbe24"
import script from "./kindFile.vue?vue&type=script&lang=js"
export * from "./kindFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports